import { UIActionType, UIAction } from '../../actions/uiActions';

const currentOrganizationReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_CURRENT_ORGANIZATION_ID) return action.id;
  return state;
};

export default currentOrganizationReducer;
